import { EnumSchema, Executor, FromSchema } from '@40seas/entities/common';
import { Currency, Segment, SegmentEntity, WithSegmentBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { HeronReportFinancialConnectionUpload, HeronReportFinancialConnectionUploadSchema } from './heron-report.financial-data-upload';
import { HeronReportStatus } from './heron-report.status.enum';
import { HeronReportCreditScore, HeronReportCreditScoreSchema } from './heron-report.credit-score';

export const HeronReportSchema = WithSegmentBaseEntitySchema(
    z.object({
        heronCompany: z.string(),
        buyer: z.string().nullish(),
        financialConnections: z.array(HeronReportFinancialConnectionUploadSchema),
        status: EnumSchema(HeronReportStatus),
        confidence: z.number().nullish(),
        creditScore: HeronReportCreditScoreSchema.nullish().optional(),
        totalTransactionsCount: z.number().nullish(),

        annualRevenue: z.number().nullish(),
        nsfOverdraftCases: z.number().nullish(),
        totalThreeMonthsDeptRepayment: z.number().nullish(),
        avgDebtRepayment: z.number().nullish(),
        netProfit: z.number().nullish(),
        monthsOfBankData: z.number().nullish(),
        newDebt: z.number().nullish(),
        balance: z.number().nullish(),
        negativeBalanceDays: z.number().nullish(),
        monthsOfBankStatementData: z.number().nullish(),
        currency: EnumSchema(Currency).nullish(),
        revenueSources: z.number().nullish(),
        avg90DaysBalance: z.number().nullish(),
    }),
).strict();

export class HeronReport extends FromSchema(HeronReportSchema) implements SegmentEntity {
    id: string;
    buyer: string;
    heronCompany: string;
    financialConnections: HeronReportFinancialConnectionUpload[];
    status: HeronReportStatus;
    confidence?: number;
    creditScore?: HeronReportCreditScore;

    annualRevenue?: number;
    nsfOverdraftCases: number;
    newDebt: number;
    avgDebtRepayment: number;
    monthsOfBankData: number;
    negativeBalanceDays: number;
    monthsOfBankStatementData: number;
    totalTransactionsCount: number;
    netProfit: number;
    balance: number;
    currency: Currency;
    revenueSources: number;
    avg90DaysBalance: number;

    segments?: Segment[];
    createdAt: Date;
    updatedAt: Date;
    tenantId: string;
    seller?: string;
    createdBy: Executor;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
